import React, { useEffect, useState } from 'react';
// Import the progress bar component
import StepProgressBar from 'react-step-progress';
// Import the stylesheet
import 'react-step-progress/dist/index.css';
import "../../css/stepform.css"
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import Step4 from './step4';

// Step 1 content
const step1Content = <><Step1 /></>;

// Step 2 content
const step2Content = <><Step2 /></>;

// Step 3 content
const step3Content = <><Step3 /></>;

// Step 4 content
const step4Content = <><Step4 /></>;

// Step 2 validation
function step2Validator() {
    // Replace this logic with your own validation (example returns true)
    return true;
}

// Step 3 validation
function step3Validator() {
    // Replace this logic with your own validation (example returns true)
    return true;
}

// Step 4 validation
function step4Validator() {
    // Replace this logic with your own validation (example returns true)
    return true;
}

// Final submit handler
function onFormSubmit() {
    // alert('Form submitted!');
}

const StepForm = () => {

    return (
        <>
            <div className='stepform'>
                <StepProgressBar
                    startingStep={0}
                    onSubmit={onFormSubmit}
                    steps={[
                        {
                            label: 'Project Initialization',
                            // subtitle: '10%',
                            name: 'step 1',
                            content: step1Content
                        },
                        {
                            label: 'Provide Token Information',
                            // subtitle: '50%',
                            name: 'step 2',
                            content: step2Content,
                            validator: step2Validator
                        },
                        {
                            label: 'Configure Launchpad Parameters',
                            // subtitle: '100%',
                            name: 'step 3',
                            content: step3Content,
                            validator: step3Validator
                        },
                        {
                            label: 'Plan Token Release Schedule',
                            // subtitle: '100%',
                            name: 'step 4',
                            content: step4Content,
                            validator: step4Validator
                        }
                    ]}
                    /* Customization props below */
                    wrapperClass="my-wrapper"
                    progressClass="my-progress-bar"
                    stepClass="my-step"
                    labelClass="my-label"
                    subtitleClass="my-subtitle"
                    contentClass="my-content"
                    buttonWrapperClass="my-button-wrapper"
                    primaryBtnClass="my-next-btn"
                    secondaryBtnClass="my-prev-btn"
                    previousBtnName="Go Back"
                    nextBtnName="Continue"
                />
            </div>
        </>
    );
};

export default StepForm;
